import {
  SET_CONNECTION, UPDATE_SYSTEM_DATA, SET_SELECTED_SCREEN,
  SET_HISTORY_DATA, ADD_HISTORY_POINT, SET_SCREENSHOT
} from '../../actions/screenInformation';

const initialState = {
  screens: {},
  selectedScreenId: null,
  historyData: [],
  screenshots: {},
  isConnected: false,
};

export const systemReducer = (state = initialState, action) => {
  console.log(state, action, 'systemReducer');
  switch (action.type) {
    case SET_CONNECTION:
      return { ...state, isConnected: action.payload };
      
    case UPDATE_SYSTEM_DATA:
      return { 
        ...state, 
        screens: { ...state.screens, [action.payload.screenId]: action.payload } 
      };
      
    case SET_SELECTED_SCREEN:
      return { ...state, selectedScreenId: action.payload };
      
    case SET_HISTORY_DATA:
      return { ...state, historyData: action.payload };
      
    case ADD_HISTORY_POINT: {
      const newData = [...state.historyData, action.payload];
      if (newData.length > 20) newData.shift(); // Keep max 20 points
      return { ...state, historyData: newData };
    }
      
    case SET_SCREENSHOT:
      return {
        ...state,
        screenshots: {
          ...state.screenshots,
         image: `data:image/jpeg;base64,${action.payload.image}`
        }
      };
      
    default:
      return state;
  }
};